<template>
  <div data-aos="fade-up" data-aos-offset="0" class="announceDetail">
    <v-container fluid>
      <v-container class="pa-0">
        <v-breadcrumbs :items="breadItems" divider="/"></v-breadcrumbs>
      </v-container>
      <v-container class="px-12">
        <h3 class="sr-only">{{ item.title }}</h3>
        <v-row class="mb-6">
          <v-col
            cols="12"
            class="ct-text-subtitle ct-text-bolder mb-0 d-flex justify-center align-center"
          >
            <!-- <div>
            <v-img
              :src="require('@/assets/images/book/book_icon.svg')"
              contain
              class="mx-3"
              height="29"
              width="25"
            />
          </div> -->
            <span class="card-title" style="display:inline-block">{{
              item.title
            }}</span>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center white ">
          <v-col
            cols="10"
            class="mb-0 d-flex justify-sm-space-around justify-md-space-between align-center flex-wrap"
          >
            <div
              class="ma-1 categoryItem"
              style="width:150px;"
              :style="{
                backgroundColor: SYS.setCategoryBgColor(item.subcategory)
              }"
            >
              {{ SYS.setCategory(item.subcategory) }}
            </div>
            <div v-if="item.important" class="ma-1 importantChip">
              精選
            </div>
            <v-spacer />
            <div class="grey--text">
              公告日期：{{ TOOL.setDateString(item.onlineDate) }}
            </div>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center white">
          <v-col cols="10">
            <v-divider />
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center white">
          <v-col cols="10" lg="8">
            <v-container v-if="item.subcategory == 16">
              <v-row>
                <v-col>
                  <div class="ct-text-subtitle ct-text-bolder">目標：</div>
                  <p>{{ item.content.Target }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <div class="ct-text-subtitle ct-text-bolder">
                    進行方式：
                  </div>
                  <p>{{ item.content.Proceed }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <div class="ct-text-subtitle ct-text-bolder">
                    成果描述：
                  </div>
                  <p>{{ item.content.Result }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <div class="ct-text-subtitle ct-text-bolder">
                    實施心得：
                  </div>
                  <p>{{ item.content.Practice }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <div class="ct-text-subtitle ct-text-bolder">
                    學習者心得：
                  </div>
                  <p>{{ item.content.Learn }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <div class="ct-text-subtitle ct-text-bolder">補充：</div>
                  <p>{{ item.content.Note }}</p>
                </v-col>
              </v-row>
            </v-container>
            <v-container v-else>
              <v-row>
                <v-col
                  class="content-wrapper"
                  v-html="TOOL.replaceUnitToRem(item.content.Result)"
                >
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
        <v-row
          class="d-flex justify-center white"
          v-if="item.subcategory != 16"
        >
          <v-col cols="9">
            <PhotoList :item="item" :topic="item.title" />
          </v-col>
        </v-row>
        <v-row
          class="d-flex justify-center white"
          v-if="!(item.file == null || typeof item.file == 'undefined')"
        >
          <v-col cols="10" lg="8">
            <FileList :item="item" />
          </v-col>
        </v-row>
        <v-row class="white">
          <v-col class="my-6 d-flex justify-center align-center mx-auto">
            <ListBack />
          </v-col>
        </v-row>
        <NextList :list="list" :idx="idx" @item="setItem" @idx="setIdx" />
      </v-container>
    </v-container>
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/layouts/footer.vue";
import FileList from "@/components/ui/detailComponent/FileList.vue";
import NextList from "@/components/ui/detailComponent/NextList.vue";
import PhotoList from "@/components/ui/detailComponent/PhotoList.vue";
import ListBack from "@/components/ui/detailComponent/ListBack.vue";
import Model from "@/assets/javascript/System/Model";
import { scrollToTopMixin } from "@/mixins/scrollToTop.js";

export default {
  mixins: [scrollToTopMixin],
  components: {
    Footer,
    FileList,
    NextList,
    PhotoList,
    ListBack
  },
  data() {
    return {
      breadItems: [
        {
          text: "愛樹教育",
          disabled: false,
          to: "/Education/"
        }
      ],
      list: [],
      idx: 0,
      nextContent: false,
      item: {
        sno: -1,
        category: 1,
        title: "標題",
        onlineDate: Date.now(),
        content: "內容"
      }
    };
  },
  watch: {
    item() {
      this.breadItems = [
        {
          text: "愛樹教育",
          disabled: false,
          to: "/Education/"
        }
      ];
      this.breadItems.push({
        text: this.item.title,
        disabled: true,
        href: "breadcrumbs_link_1"
      });
      document.title += "-" + this.item.title;
    }
  },
  mounted() {
    if (typeof this.$route.query.idx !== "undefined") {
      this.idx = this.$route.query.idx;
    }
    if (typeof this.$route.params.item !== "undefined") {
      this.item = this.$route.params.item;
      this.getList();
    } else {
      this.getDetail();
    }

    // if (typeof this.$route.query.idx !== "undefined") {
    //   this.idx = this.$route.query.idx;
    //   this.nextContent = false;
    //   this.$store.dispatch("setProcessWait", [
    //     this.$store.dispatch("getEducationList").then(() => {
    //       this.list = this.$store.state.education.list.filter(
    //         p => p.subcategory == this.item.subcategory
    //       );
    //       this.nextContent = true;
    //       if (typeof this.$route.query.name !== "undefined") {
    //         let target = this.list.findIndex(
    //           p => p.Sno == this.$route.query.name
    //         );
    //         if (target >= 0) {
    //           this.idx = target;
    //         }
    //       }
    //       this.item = this.list[this.idx];

    //       this.breadItems.push({
    //         text: this.item.title,
    //         disabled: true,
    //         href: "breadcrumbs_link_1"
    //       });
    //     })
    //   ]);
    // }
  },
  computed: {
    cTitleImg() {
      return require("@/assets/images/temp/temp_announce_item.png");
    }
  },
  methods: {
    setItem(val) {
      this.item = val;
    },
    setIdx(val) {
      this.idx = val;
    },
    getDetail() {
      return this.axios({
        methods: "get",
        url: `${process.env.VUE_APP_API_URL}api/Education/GetEducationDetail`,
        params: {
          sno: this.$route.query.name
        }
      }).then(resp => {
        this.item = Model.ModelEduItem(resp.data.data);
        if (
          typeof this.item.photoList !== "undefined" &&
          this.item.photoList.length > 0
        ) {
          this.photoList = this.item.photoList;
          this.photoItem = this.item.photoList[0];
        }
        this.getList();
      });
    },
    async getList() {
      const list = this.$store.state.education.list;
      if (list.length === 0) {
        await this.$store.dispatch("getEducationList");
      }
      this.list = this.$store.state.education.list.filter(
        p =>
          p.category === this.item.category &&
          p.subcategory === this.item.subcategory
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.announceDetail {
  background-color: #f6edd9;
}
// p:before {
//   content: "\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0";
// }
p {
  white-space: pre-wrap;
}
</style>
